import { makeStyles } from '@material-ui/styles'

export const parkingButtonPanelStyles = makeStyles((theme) => ({
  mapWarningOverlay: {
    position: 'absolute',
    top: '55px',
    left: '85px',
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,
    background: theme.palette.base.yellow,
    color: theme.palette.base.black,
    textAlign: 'left',
  },
  mapWarningOverlayButton: {
    marginTop: 10,
    color: 'white',
    background: theme.color.rutgersRed,
    '&:hover': {
      color: 'white',
      background: theme.color.rutgersRed,
    },
  },
}))

export default parkingButtonPanelStyles
